import { FC } from 'react';
import ConfigureItemsGrid from '@flows/src/components/flows-configure/shared/ConfigureItemsGrid';
import FlowsConfigureInsuranceItem from '@flows/src/components/flows-configure/insurances/FlowsConfigureInsuranceItem';
import SelectAllButton from '@flows/src/components/flows-configure/shared/SelectAllButton';
import { useYellowhiveFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/yellowhiveFlowsConfigureStore';
import { GetSupportedYellowhiveflowInsurancesResponse } from 'wg-api-sdk';

interface Props {
  items: GetSupportedYellowhiveflowInsurancesResponse['items'];
  isError?: boolean;
  clearError?: () => void;
}

const FlowsConfigureInsuranceItems: FC<Props> = ({
  items,
  isError,
  clearError,
}) => {
  const setInsurances = useYellowhiveFlowsConfigureStore(
    (state) => state.setInsurances,
  );
  const isAllSelected = useYellowhiveFlowsConfigureStore(
    (state) => state.insurances?.length === items.length,
  );

  const handleSelectAllInsurances = () => {
    setInsurances(items);
  };

  const handleDeselectAll = () => {
    setInsurances([]);
  };

  return (
    <ConfigureItemsGrid singleColumn={items.length === 1}>
      {items.length > 1 && (
        <SelectAllButton
          isAllSelected={isAllSelected}
          onDeselectAll={handleDeselectAll}
          onSelectAll={handleSelectAllInsurances}
        />
      )}
      {items.map((item) => (
        <FlowsConfigureInsuranceItem
          key={item.code}
          insurance={item}
          isError={isError}
          clearError={clearError}
        />
      ))}
    </ConfigureItemsGrid>
  );
};

export default FlowsConfigureInsuranceItems;
